import React, { useState, useEffect } from "react";
import "./Gallery.scss";

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const openImage = (src) => {
    setSelectedImage(src);
  };
  const closeImage = () => {
    setSelectedImage(null);
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const imagesArt = [
    {
      src: "./obras/mauro-testa_fotografia_formaslatentes_01.jpg?v=1",
      title: "mauro-testa_fotografia_formaslatentes_01",
    },
    {
      src: "./obras/mauro-testa_fotografia_formaslatentes_02.jpg?v=1",
      title: "mauro-testa_fotografia_formaslatentes_02",
    },
    {
      src: "./obras/mauro-testa_fotografia_formaslatentes_04.jpg?v=1",
      title: "mauro-testa_fotografia_formaslatentes_04",
    },
    {
      src: "./obras/mauro-testa_fotografia_formaslatentes_05.jpg?v=1",
      title: "mauro-testa_fotografia_formaslatentes_05",
    },
    {
      src: "./obras/mauro-testa_fotografia_formaslatentes_06.jpg?v=1",
      title: "mauro-testa_fotografia_formaslatentes_06",
    },
    {
      src: "./obras/mauro-testa_fotografia_formaslatentes_07.jpg?v=1",
      title: "mauro-testa_fotografia_formaslatentes_07",
    },
    {
      src: "./obras/mauro-testa_fotografia_formaslatentes_08.jpg?v=1",
      title: "mauro-testa_fotografia_formaslatentes_08",
    },
    { src: "./obras/mauro-testa_fotografia_formaslatentes_09.jpg?v=1", title: "mauro-testa_fotografia_formaslatentes_09" },
    {
      src: "./obras/mauro-testa_fotografia_formaslatentes_10.jpg?v=1",
      title: "mauro-testa_fotografia_formaslatentes_10",
    },
    {
      src: "./obras/mauro-testa_fotografia_formaslatentes_11.jpg?v=1",
      title: "mauro-testa_fotografia_formaslatentes_11",
    },
            {
      src: "./obras/mauro-testa_fotografia_formaslatentes_03.jpg?v=1",
      title: "mauro-testa_fotografia_formaslatentes_03",
    },
    {
      src: "./obras/mauro-testa_fotografia_formaslatentes_11.jpg?v=1",
      title: "mauro-testa_fotografia_formaslatentes_11",
    },
    {
      src: "./obras/mauro-testa_fotografia_formaslatentes_12.jpg?v=1",
      title: "mauro-testa_fotografia_formaslatentes_12",
    },
    {
      src: "./obras/mauro-testa_fotografia_formaslatentes_13.jpg?v=1",
      title: "mauro-testa_fotografia_formaslatentes_13",
    },
    {
      src: "./obras/mauro-testa_fotografia_formaslatentes_14.jpg?v=1",
      title: "mauro-testa_fotografia_formaslatentes_14",
    },
    {
      src: "./obras/mauro-testa_fotografia_formaslatentes_15.jpg?v=1",
      title: "mauro-testa_fotografia_formaslatentes_15",
    },
    {
      src: "./obras/mauro-testa_fotografia_formaslatentes_16.jpg?v=1",
      title: "mauro-testa_fotografia_formaslatentes_16",
    },
    {
      src: "./obras/mauro-testa_fotografia_formaslatentes_17.jpg?v=1",
      title: "mauro-testa_fotografia_formaslatentes_17",
    },
    {
      src: "./obras/mauro-testa_fotografia_formaslatentes_18.jpg?v=1",
      title: "mauro-testa_fotografia_formaslatentes_18",
    },
    {
      src: "./obras/mauro-testa_fotografia_formaslatentes_19.jpg?v=1",
      title: "mauro-testa_fotografia_formaslatentes_19",
    },

  ];
  const imagesFashion = [
        {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_maral01.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_maral01",
    },
            {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_Ju_02.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_Ju_02",
    },
            {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_cy03.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cy03",
    },
                {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_luis01.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_luis01",
    },
                {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_Nana_02.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_Nana_02",
    },
        {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_moon06.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_moon06",
    },
            {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_cy02.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cy02",
    },
            {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_Ju_01.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_Ju_01",
    },
        {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_bf01.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_bf01",
    },
    {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_Dav_01.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_Dav_01",
    },
    {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_Nana_01.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_Nana_01",
    },
        {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_cy06.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cy06",
    },
        {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_td1.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_td1",
    },
    {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_moon01.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_moon01",
    },
    {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_moon03.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_moon03",
    },
    {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_maria03.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_maria03",
    },
    {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_Ju_03.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_Ju_03",
    },
    {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_ella2.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_ella2",
    },
    {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_mar01.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_mar01",
    },
        {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_cy05.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cy05",
    },
        {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_Nana_03.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_Nana_03",
    },
    {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_mar03.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_mar03",
    },
        {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_bf02.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_bf02",
    },
        {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_cy01.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cy01",
    },
    {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_maral02.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_maral02",
    },
    {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_Ju_04.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_Ju_04",
    },
    {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_Nana_04.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_Nana_04",
    },
        {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_cy04.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cy04",
    },
            {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_Dav_02.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_Dav_02",
    },
            {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_Var_01.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_Var_01",
    },
    {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_ella4.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_ella4",
    },
    {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_bf04.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_bf04",
    },
        {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_uvfn3.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_uvfn3",
    },
        {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_Nana_05.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_Nana_05",
    },
    {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_uvfn1.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_uvfn1",
    },
    {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_Ju_05.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_Ju_05",
    },
    {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_bf03.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_bf03",
    },
        {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_moon04.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_moon04",
    },
        {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_cy07.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cy07",
    },
    {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_yatu01.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_yatu01",
    },
     {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_maral04.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_maral04",
    },
    {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_bf05.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_bf05",
    },
    {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_ella6.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_ella6",
    },
    {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_uvfn4.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_uvfn4",
    },
    {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_maral03.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_maral03",
    },
    {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_vp3.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_vp3",
    },
        {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_moon02.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_moon02",
    },
        {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_den01.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_den01",
    },
    {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_diana01.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_diana01",
    },
        {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_lb.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_lb",
    },
        {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_moon07.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_moon07",
    },
    {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_td2.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_td2",
    },
            {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_Var_02.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_Var_02",
    },
        {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_maria01.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_maria01",
    },
    { src: "./fashion/mauro-testa_fotografiademoda__fotografo_vp4.jpg?v=1", title: "mauro-testa_fotografiademoda__fotografo_vp4" },
    {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_bbyn.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_bbyn",
    },
            {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_moon05.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_moon05",
    },
        {
      src: "./fashion/mauro-testa_fotografiademoda__fotografo_mar02.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_mar02",
    },
  ];

  const imagesCovers = [
    {
      src: "./covers/mauro-testa_fotografiademoda__fotografo_cover_20.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cover_20",
    },
    {
      src: "./covers/mauro-testa_fotografiademoda__fotografo_cover_17.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cover_17",
    },
    {
      src: "./covers/mauro-testa_fotografiademoda__fotografo_cover_18.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cover_18",
    },
    {
      src: "./covers/mauro-testa_fotografiademoda__fotografo_cover_25.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cover_25",
    },
    {
      src: "./covers/mauro-testa_fotografiademoda__fotografo_cover_28.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cover_28",
    },
    {
      src: "./covers/mauro-testa_fotografiademoda__fotografo_cover_15.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cover_15",
    },
    {
      src: "./covers/mauro-testa_fotografiademoda__fotografo_cover_02.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cover_02",
    },
    {
      src: "./covers/mauro-testa_fotografiademoda__fotografo_cover_07.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cover_07",
    },
    {
      src: "./covers/mauro-testa_fotografiademoda__fotografo_cover_21.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cover_21",
    },
    {
      src: "./covers/mauro-testa_fotografiademoda__fotografo_cover_19.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cover_19",
    },
    {
      src: "./covers/mauro-testa_fotografiademoda__fotografo_cover_24.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cover_24",
    },
    {
      src: "./covers/mauro-testa_fotografiademoda__fotografo_cover_26.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cover_26",
    },
    {
      src: "./covers/mauro-testa_fotografiademoda__fotografo_cover_01.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cover_01",
    },
    {
      src: "./covers/mauro-testa_fotografiademoda__fotografo_cover_03.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cover_03",
    },
    {
      src: "./covers/mauro-testa_fotografiademoda__fotografo_cover_04.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cover_04",
    },
    {
      src: "./covers/mauro-testa_fotografiademoda__fotografo_cover_09.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cover_09",
    },
    {
      src: "./covers/mauro-testa_fotografiademoda__fotografo_cover_10.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cover_10",
    },
    {
      src: "./covers/mauro-testa_fotografiademoda__fotografo_cover_12.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cover_12",
    },
    {
      src: "./covers/mauro-testa_fotografiademoda__fotografo_cover_14.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cover_14",
    },
    {
      src: "./covers/mauro-testa_fotografiademoda__fotografo_cover_13.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cover_13",
    },
    {
      src: "./covers/mauro-testa_fotografiademoda__fotografo_cover_22.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cover_22",
    },
    {
      src: "./covers/mauro-testa_fotografiademoda__fotografo_cover_27.jpg?v=1",
      title: "mauro-testa_fotografiademoda__fotografo_cover_27",
    },
  ];
  const imagesPortrait = [
    {
      src: "./portraits/mauro-testa_portrait__fotografo_ania01.jpg?v=1",
      title: "mauro-testa_portrait__fotografo_ania01",
    },
    {
      src: "./portraits/mauro-testa_portrait__fotografo_aleja3.jpg?v=1",
      title: "mauro-testa_portrait__fotografo_aleja3",
    },
    {
      src: "./portraits/mauro-testa_portrait__fotografo_pas03.jpg?v=1",
      title: "mauro-testa_portrait__fotografo_pas03",
    },
    {
      src: "./portraits/mauro-testa_portrait__fotografo_ant.jpg?v=1",
      title: "mauro-testa_portrait__fotografo_ant",
    },
    {
      src: "./portraits/mauro-testa_portrait__fotografo_nat02.jpg?v=1",
      title: "mauro-testa_portrait__fotografo_nat02",
    },
    {
      src: "./portraits/mauro-testa_portrait__fotografo_ania02.jpg?v=1",
      title: "mauro-testa_portrait__fotografo_ania02",
    },
    {
      src: "./portraits/mauro-testa_portrait__fotografo_alex.jpg?v=1",
      title: "mauro-testa_portrait__fotografo_alex",
    },
    {
      src: "./portraits/mauro-testa_portrait__fotografo_nat01.jpg?v=1",
      title: "mauro-testa_portrait__fotografo_nat01",
    },
    {
      src: "./portraits/mauro-testa_portrait__fotografo_ania03.jpg?v=1",
      title: "mauro-testa_portrait__fotografo_ania03",
    },
    {
      src: "./portraits/mauro-testa_portrait__fotografo_pasc2.jpg?v=1",
      title: "mauro-testa_portrait__fotografo_pasc2",
    },
    {
      src: "./portraits/mauro-testa_portrait__fotografo_pas02.jpg?v=1",
      title: "mauro-testa_portrait__fotografo_pas02",
    },
    {
      src: "./portraits/mauro-testa_portrait__fotografo_aleja.jpg?v=1",
      title: "mauro-testa_portrait__fotografo_aleja",
    },
    {
      src: "./portraits/mauro-testa_portrait__fotografo_ant2.jpg?v=1",
      title: "mauro-testa_portrait__fotografo_ant2",
    },
    {
      src: "./portraits/mauro-testa_portrait__fotografo_pas01.jpg?v=1",
      title: "mauro-testa_portrait__fotografo_pas01",
    },
    {
      src: "./portraits/mauro-testa_portrait__fotografo_pasc.jpg?v=1",
      title: "mauro-testa_portrait__fotografo_pasc",
    },
    {
      src: "./portraits/mauro-testa_portrait__fotografo_aleja2.jpg?v=1",
      title: "mauro-testa_portrait__fotografo_aleja2",
    },
  ];
  const imagesBbc = [
    {
      src: "./bbc/maurotesta_fotografiadebodasbautizoscomuniones__fotografo_bo6.jpg?v=1",
      title: "maurotesta_fotografiadebodasbautizoscomuniones__fotografo_bo6",
    },
    {
      src: "./bbc/maurotesta_fotografiadebodasbautizoscomuniones__fotografo_bo13.jpg?v=1",
      title: "maurotesta_fotografiadebodasbautizoscomuniones__fotografo_bo13",
    },
    {
      src: "./bbc/maurotesta_fotografiadebodasbautizoscomuniones__fotografo_co4.jpg?v=1",
      title: "maurotesta_fotografiadebodasbautizoscomuniones__fotografo_co4",
    },
    {
      src: "./bbc/maurotesta_fotografiadebodasbautizoscomuniones__fotografo_ba.jpg?v=1",
      title: "maurotesta_fotografiadebodasbautizoscomuniones__fotografo_ba",
    },
    {
      src: "./bbc/maurotesta_fotografiadebodasbautizoscomuniones__fotografo_bo5.jpg?v=1",
      title: "maurotesta_fotografiadebodasbautizoscomuniones__fotografo_bo5",
    },
    {
      src: "./bbc/maurotesta_fotografiadebodasbautizoscomuniones__fotografo_bo10.jpg?v=1",
      title: "maurotesta_fotografiadebodasbautizoscomuniones__fotografo_bo10",
    },
    {
      src: "./bbc/maurotesta_fotografiadebodasbautizoscomuniones__fotografo_co.jpg?v=1",
      title: "maurotesta_fotografiadebodasbautizoscomuniones__fotografo_co",
    },
    {
      src: "./bbc/maurotesta_fotografiadebodasbautizoscomuniones__fotografo_bo15.jpg?v=1",
      title: "maurotesta_fotografiadebodasbautizoscomuniones__fotografo_bo15",
    },
    {
      src: "./bbc/maurotesta_fotografiadebodasbautizoscomuniones__fotografo_bo8.jpg?v=1",
      title: "maurotesta_fotografiadebodasbautizoscomuniones__fotografo_bo8",
    },
    {
      src: "./bbc/maurotesta_fotografiadebodasbautizoscomuniones__fotografo_co10.jpg?v=1",
      title: "maurotesta_fotografiadebodasbautizoscomuniones__fotografo_co10",
    },
    {
      src: "./bbc/maurotesta_fotografiadebodasbautizoscomuniones__fotografo_bo12.jpg?v=1",
      title: "maurotesta_fotografiadebodasbautizoscomuniones__fotografo_bo12",
    },
    {
      src: "./bbc/maurotesta_fotografiadebodasbautizoscomuniones__fotografo_bo3.jpg?v=1",
      title: "maurotesta_fotografiadebodasbautizoscomuniones__fotografo_bo3",
    },
    {
      src: "./bbc/maurotesta_fotografiadebodasbautizoscomuniones__fotografo_co3.jpg?v=1",
      title: "maurotesta_fotografiadebodasbautizoscomuniones__fotografo_co3",
    },
    {
      src: "./bbc/maurotesta_fotografiadebodasbautizoscomuniones__fotografo_bo14.jpg?v=1",
      title: "maurotesta_fotografiadebodasbautizoscomuniones__fotografo_bo14",
    },
    {
      src: "./bbc/maurotesta_fotografiadebodasbautizoscomuniones__fotografo_bo2.jpg?v=1",
      title: "maurotesta_fotografiadebodasbautizoscomuniones__fotografo_bo2",
    },
    {
      src: "./bbc/maurotesta_fotografiadebodasbautizoscomuniones__fotografo_ba2.jpg?v=1",
      title: "maurotesta_fotografiadebodasbautizoscomuniones__fotografo_ba2",
    },
    {
      src: "./bbc/maurotesta_fotografiadebodasbautizoscomuniones__fotografo_ba3.jpg?v=1",
      title: "maurotesta_fotografiadebodasbautizoscomuniones__fotografo_ba3",
    },
    {
      src: "./bbc/maurotesta_fotografiadebodasbautizoscomuniones__fotografo_bo11.jpg?v=1",
      title: "maurotesta_fotografiadebodasbautizoscomuniones__fotografo_bo11",
    },
    {
      src: "./bbc/maurotesta_fotografiadebodasbautizoscomuniones__fotografo_co7.jpg?v=1",
      title: "maurotesta_fotografiadebodasbautizoscomuniones__fotografo_co7",
    },
    {
      src: "./bbc/maurotesta_fotografiadebodasbautizoscomuniones__fotografo_co8.jpg?v=1",
      title: "maurotesta_fotografiadebodasbautizoscomuniones__fotografo_co8",
    },
  ];

  return (
    <div className="gallery">
      {window.location.pathname.includes("/art") &&
        imagesArt.map((image, index) => (
          <div className="gallery__cont" key={index}>
            <img
              className="gallery__cont--img"
              src={image.src}
              alt={image.title}
              loading="lazy"
              onClick={() => openImage(image.src)}
            />
          </div>
        ))}
      {window.location.pathname.includes("/fashion") &&
        imagesFashion.map((image, index) => (
          <div className="gallery__cont" key={index}>
            <img
              className="gallery__cont--img"
              src={image.src}
              alt={image.title}
              loading="lazy"
              onClick={() => openImage(image.src)}
            />
          </div>
        ))}
      {window.location.pathname.includes("/portrait") &&
        imagesPortrait.map((image, index) => (
          <div className="gallery__cont" key={index}>
            <img
              className="gallery__cont--img"
              src={image.src}
              alt={image.title}
              loading="lazy"
              onClick={() => openImage(image.src)}
            />
          </div>
        ))}
      {window.location.pathname.includes("/music") &&
        imagesCovers.map((image, index) => (
          <div className="covers" key={index}>
            <img
              className="coversInd"
              src={image.src}
              alt={image.title}
              loading="lazy"
              onClick={() => openImage(image.src)}
            />
            <p class="texto">Available</p>
          </div>
        ))}
      {window.location.pathname.includes("/bodasbautizosycomuniones") &&
        imagesBbc.map((image, index) => (
          <div className="gallery__cont" key={index}>
            <img
              className="gallery__cont--img"
              src={image.src}
              alt={image.title}
              loading="lazy"
              onClick={() => openImage(image.src)}
            />
            <p class="texto">Available</p>
          </div>
        ))}
      {selectedImage && windowWidth >= 1000 && (
        <div className="lightbox">
          <div className="lightbox__overlay" onClick={closeImage}></div>
          <div className="lightbox__content">
            <img src={selectedImage} alt="Large Image" />
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
